module.exports = __webpack_public_path__ + "static/media/icon-arrow-backward.efd738f5.svg";